import { matchPath, useLocation } from 'react-router-dom'
import ROUTE_PATTERNS from '../consts/routes'

/**
 * Normalize a react-router `to` value down to a pathname so query strings still match a route.
 * @param {string|{ pathname?: string }|undefined} target
 * @param {string} [fallback]
 * @returns {string}
 */
export const getRoutePathname = (target, fallback) => {
    const pathname = typeof target === 'string' ? target : target?.pathname
    return (pathname || fallback || '').split(/[?#]/)[0]
}

/**
 * Determines the current route key based on the provided pathname or the current location.
 * Iterates through the predefined ROUTE_PATTERNS to find the first matching pattern.
 * 
 * @param {string} [pathname] - Optional pathname to match against. Defaults to current location.
 * @returns {string|null} The matching route pattern string, or null if no match is found.
 */
const useCurrentRouteKey = (pathname) => {
    const location = useLocation()
    const routePathname = getRoutePathname(pathname, location?.pathname)
    const matchRoute = path => matchPath(routePathname, path)

    // return the first matching route key
    for (const [, pattern] of Object.entries(ROUTE_PATTERNS)) {
        if (matchRoute(pattern)) {
            // root pattern is the same as the dashboard pattern
            return pattern === ROUTE_PATTERNS.ROOT ? ROUTE_PATTERNS.DASHBOARD : pattern
        }
    }
    return null
}

export default useCurrentRouteKey